<template>
  <!--
      作者：gmshop
      时间：2020-06-01
      描述：插件中心-文章-添加
    -->
  <div class="product-add pb50">
   <!--添加文章-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加</div>
      <el-form-item label="标题" prop="title"><el-input v-model="form.title" placeholder="请输入标题" class="max-w460"></el-input></el-form-item>
      <el-form-item label="联系方式" prop="mobile"><el-input v-model="form.mobile" placeholder="请输入联系方式" class="max-w460"></el-input></el-form-item>
      <el-form-item label="活动开始时间">
        <el-date-picker
          v-model="form.activity_time"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          ></el-date-picker>
      </el-form-item>
      <el-form-item label="描述" prop="dec">
        <el-input type="textarea" rows="8" v-model="form.dec" placeholder="请输入描述" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="封面"  :rules="[{ required: true, message: '请上传封面图片' }]" prop="img_url">
         <div>
           <gm-tips content="建议尺寸750x750" />
           <el-button type="primary" @click="openUpload('image')">上传图片</el-button>
           <img :src="form.img_url" class="mt10" width="120px;" v-if="form.img_url"/>
         </div>
       </el-form-item>

      <el-form-item label="图片：" :rules="[{ required: true, message: '请上传图片' }]" prop="image">
        <div slot="label">图片：</div>
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div class="item" v-for="(item, index) in form.image" :key="item.file_path">
                <el-image 
                  style="width: 100px; height: 100px"
                  :src="item.file_path" 
                  :preview-src-list="[item.file_path]">
                </el-image>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openUpload('images')"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 50 }" @returnImgs="returnImgsFunc">上传图片</Upload>

      <el-form-item label="视频封面图：" prop="poster">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('poster')">选择图片
          </el-button>
          <div class="draggable-list">
            <div v-if="form.poster !== ''" class="img item">
              <img :src="form.poster" width="100" height="100" alt="poster"/>
            </div>
          </div>
        </el-row>

      </el-form-item>

      <el-form-item label="视频：" prop="video">
        <el-input type="text" v-model="form.video_url" placeholder="请选择视频" class="max-w460">
          <template slot="append">
            <el-button icon="el-icon-picture-outline" @click="openUpload('video')">选择视频
            </el-button>
          </template>
        </el-input>
        <div class="gray9">仅支持mp4格式的文件，请选择视频文件，或者直接复制视频文件地址到此处</div>
      </el-form-item>
      <el-form-item label="报名积分 " prop="points" min='0'  :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入积分" type="number" min="0" v-model="form.points" class="max-w460">
          <template slot="append">积分/人</template>
        </el-input>
      </el-form-item>
      <el-form-item label="活动人数 " prop="points" min='0' >
        <el-input placeholder="请输入人数" type="number" min="0" v-model="form.limit_num" class="max-w460">
          <template slot="append">人</template>
        </el-input>
        <div class="gray">为零不限制</div>
      </el-form-item>
      <!-- <el-form-item label="接待时间" prop="service_time">
         <el-input v-model="form.service_time" placeholder="请输入接待时间如：10:00-18:00" class="max-w460"></el-input>
        </el-form-item> -->
      <el-form-item label="接待时间" prop="service_time">
         <el-time-picker
           v-model="form.service_time"
           type="timerange"
           align="right"
           is-range
           unlink-panels
           range-separator="至"
           start-placeholder="开始时间"
           end-placeholder="结束时间"
           format="HH:mm"
           value-format="HH:mm"
           ></el-time-picker>
       </el-form-item>
        <el-form-item label="类型">
         <el-radio-group v-model="form.activity_type">
          <el-radio :label="0">活动报名</el-radio>
           <el-radio :label="1">门店预约</el-radio>
         </el-radio-group>
       </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
       <el-form-item label="审核状态" >
        <el-radio-group v-model="form.check_status">
          <el-radio :label="0">待审核</el-radio>
          <el-radio  :label="1">通过</el-radio>
          <!-- <el-radio  :label="2">拒绝</el-radio> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="内容">
        <div class="edit_container">
          <Uediter v-model="form.content" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>
      <el-form-item label="排序"><el-input type="number" v-model="form.sort" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import ActivityApi from '@/api/activity.js';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    /*编辑器*/
    Uediter,
    draggable,
    /*图片上传*/
    Upload: Upload
  },
  data() {
    return {
      file_type:'',
      /*是否上传图片*/
      isupload: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      path: '',
      /*form表单数据*/
      form: {
        title: '',
        points:0,
        image:[],
        img_url: '',
        limit_num: 0,
        check_status: 0,
        activity_type: 0,
        poster:'',
        video_url:'',
        sort: 1,
        status: 1,
        content: '',
        service_time: '',
        dec: '',
        /*活动时间*/
        activity_time: '',
      },
      loading: false,
      /*验证规则*/
      rules: {
       title: [{ required: true, message: '请输入标题', trigger: 'blur' }]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  created() {
  },
  methods: {
     /*上传*/
    openUpload(type) {
      this.file_type=type
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        if(self.file_type=='images'){
          let imgs = this.form.image.concat(e);
          this.$set(this.form, 'image', imgs);
        }
        if(self.file_type=='image'){
          this.form.img_url =e[0].file_path;
        }
        if(self.file_type=='poster'){
          this.form.poster =e[0].file_path;
        }
        if(self.file_type=='video'){
          this.form.video_url = e[0].file_path;
        }

      }
      this.isupload = false;
    },
    /*删除商品图片*/
    deleteImg(index) {
      this.form.image.splice(index, 1);
    },

    /*添加文章*/
    onSubmit() {
      let self = this;
      let form = self.form;
      self.form.content = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ActivityApi.addActivity(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/plus/activity/activity/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /*取消添加，返回文章列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/activity/activity/index'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/add.vue